import { useState } from "react";
import { useAppSelector } from "../../../store/hooks";
import Chat from "./Chat";
import Student from "./Student";
import styles from "./TutorLiveScreen.module.css";

enum Tabs {
  CHAT = "chat",
  STUDENTS = "students",
}
const TutorSidebarTabs = ({
  revokeSpeakingPermission,
  kickoutStudent,
  sendMessage,
  allowToSpeak,
}: {
  revokeSpeakingPermission: (id: number) => Promise<void>;
  kickoutStudent: (id: number) => Promise<void>;
  sendMessage: ({ senderId, senderName, text }) => Promise<void>;
  allowToSpeak: (id: number) => Promise<void>;
}) => {
  const [activeTab, setActiveTab] = useState(Tabs.CHAT);

  const { students, studentsNames, kickedOut } = useAppSelector(
    (state) => state.liveSession
  );

  return (
    <>
      <div className={styles.tabsBtns}>
        <button
          className={activeTab === Tabs.STUDENTS ? styles.active : ""}
          onClick={() => setActiveTab(Tabs.STUDENTS)}
        >
          الطلاب
        </button>
        <button
          className={activeTab === Tabs.CHAT ? styles.active : ""}
          onClick={() => setActiveTab(Tabs.CHAT)}
        >
          الرسائل
        </button>
      </div>
      <div className={styles.tabContent}>
        {activeTab === Tabs.STUDENTS ? (
          <div className={styles.studentsTab}>
            {students
              .filter((uid) => !kickedOut.includes(uid))
              .map((uid) => (
                <Student
                  studentId={uid}
                  studentName={studentsNames[uid]}
                  allowToSpeak={allowToSpeak}
                  revokeSpeakingPermission={revokeSpeakingPermission}
                  kickoutStudent={kickoutStudent}
                />
              ))}
          </div>
        ) : (
          <Chat sendMessage={sendMessage} />
        )}
      </div>
    </>
  );
};

export default TutorSidebarTabs;
